import {config} from "../environment";
import {useAsync} from "../utils/utils";

export type SoknadDokumentasjon = {
    filnavn: string,
    opplastningstidspunkt: string
}

export type Prissoknad = {
    søknadstype: string, //"RESØKNAD" | "FØRSTEGANG",
    brukerreferanse: string,
    innsendtdato: string,
    søknadsstatus: string, //"OVERSENDT_SAKSBEHANDLER" | "VENTER_PÅ_SKATTEOPPGJØR" | "FERDIGBEHANDLET",
    barnehagenavn: string | null,
    bydel: string,
    bydelTelefonnummer: string,
    hovedsøkerFulltNavn: string,
    brukeropplastetDokumentasjon: Array<SoknadDokumentasjon>
}

type PrissoknadResponse = {
    søknader: Array<Prissoknad>
}

async function getPrissoknader(): Promise<Array<Prissoknad>> {
    return fetch(`${config.apiUrl}/api/pris-soknader`)
        .then(res => res.json() as Promise<PrissoknadResponse>)
        .then(json =>
            json.søknader.sort((a, b) =>
                a.innsendtdato < b.innsendtdato ? 1 : -1))
}

export type AvsluttetPrissoknad = {
    søknadstype: string,
    brukerreferanse: string,
    innsendtdato: string,
}

type AvsluttetPrissoknadResponse = {
    personidentifikator: string,
    søknader: Array <AvsluttetPrissoknad>
}

async function getAvsluttedePrissoknader(): Promise<Array<AvsluttetPrissoknad>>  {
    return fetch(`${config.apiUrl}/api/pris-soknader-avsluttede`)
        .then(res => res.json() as Promise<AvsluttetPrissoknadResponse>)
        .then(json =>
            json.søknader.sort((a, b) =>
                a.innsendtdato < b.innsendtdato ? 1 : -1))
}


export const getPrissoknadKvitteringPdf = async (
    url: string
): Promise<Response> => {

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/pdf");
    headers.append("responseType", "arrayBuffer");

    const options = {
        headers: headers,
    };
    const response = await fetch(url, options);
    if (!response.ok) {
        let errorMessage = response.statusText;
        if (response.status >= 400) {
            const errorInfo = await response.json();
            errorMessage = errorInfo.message;
        }

        throw new Error(errorMessage);
    }
    return response;
};

export const usePrissoknader = useAsync(getPrissoknader)

export const useAvsluttedePrissoknader = useAsync(getAvsluttedePrissoknader)

export const erFerdigbehandlet = (søknad: Prissoknad): boolean =>
    søknad.søknadsstatus === "FERDIGBEHANDLET" || søknad.søknadsstatus === "SKAL_IKKE_BEHANDLES"

export const erAktiv = (søknad: Prissoknad): boolean =>
    søknad.søknadsstatus === "OVERSENDT_SAKSBEHANDLER" || søknad.søknadsstatus === "VENTER_PÅ_SKATTEOPPGJØR"

